import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AuthBanner } from '@src/assets/icons/AuthBanner.svg';
import { ReactComponent as LogoIcon } from '@src/assets/icons/Logo.svg';
import { ReactComponent as LogoSimpleIcon } from '@src/assets/icons/LogoSimpleIcon.svg';
import { ReactComponent as AuthBannerItemA } from '@src/assets/icons/AuthBannerItemA.svg';
import { ReactComponent as AuthBannerItemB } from '@src/assets/icons/AuthBannerItemB.svg';
import SupportForm from '../SupportForm';

type AuthScreenWrapperProps = {
    pageTitle?: string;
    subtitle?: string;
    children?: ReactNode;
    footer?: ReactNode;
};

export function AuthScreenWrapper(props: AuthScreenWrapperProps) {
    const { pageTitle, subtitle, children, footer } = props;
    const { t } = useTranslation();
    const [supportModal, setSupportModal] = useState(false);
    const toggleSupport = () => {
        setSupportModal(!supportModal);
    };
    return (
        <>
            {supportModal && (
                <SupportForm open={supportModal} onClose={toggleSupport} />
            )}
            <main
                className={`h-screen w-full bg-cover flex justify-end max-lg:justify-center max-lg:items-center max-lg:bg-primary-surface-gradient`}
            >
                <div className="flex items-center justify-center w-full h-full bg-[#E2E8F580] relative max-lg:hidden">
                    <AuthBanner className="z-[2]" />
                    <LogoSimpleIcon
                        width="100%"
                        height="100%"
                        className="absolute"
                    />
                    <div className="w-60 h-[311px] bg-white absolute top-0 right-[72px] rounded-br-[42px] rounded-bl-[42px] z-[1] flex flex-col items-center justify-center gap-4">
                        <AuthBannerItemA />
                        <span className="text-[#4C4C4C] text-xl font-normal">
                            Cost-Efficient
                        </span>
                    </div>
                    <div className="w-[286px] h-[224px] bg-white absolute bottom-[154px] left-0 rounded-br-[42px] rounded-tr-[42px] z-[1] flex flex-col items-center justify-center gap-4">
                        <AuthBannerItemB />
                        <span className="text-[#4C4C4C] text-xl font-normal">
                            Global Coverage
                        </span>
                    </div>
                </div>
                <LogoIcon
                    width={170}
                    height={58}
                    className=" absolute left-16 top-16 max-lg:hidden"
                />
                <div className="w-[624px] relative flex flex-col h-screen py-12 px-12 max-[400px]:h-screen max-[400px]:rounded-none max-lg:w-[400px] max-lg:px-6 max-lg:py-6 overflow-auto">
                    {pageTitle && (
                        <h3 className="text-on-background-light text-[32px] w-full font-bold">
                            {t(pageTitle)}
                        </h3>
                    )}
                    {subtitle && (
                        <div className="pt-3 flex flex-row gap-2 items-center w-full max-lg:pt-2">
                            <p className="text-gray-opacity font-normal text-base">
                                {t(subtitle)}
                            </p>
                            <div
                                className="p-2 bg-blue-8 rounded-s cursor-pointer"
                                onClick={toggleSupport}
                            >
                                <span className="text-primary-main font-medium text-base">
                                    {t('auth.getSupport')}
                                </span>
                            </div>
                        </div>
                    )}
                    <div className="flex-1 flex items-center justify-center w-full px-0">
                        <div className="w-full">{children}</div>
                    </div>
                    <div className="mt-auto w-full">{footer}</div>
                </div>
            </main>
        </>
    );
}
